import * as React from 'react';

export const UploadIcon = () => {
    return (
        <svg xmlns='http://www.w3.org/2000/svg' width='32.418' height='33.926' viewBox='0 0 32.418 33.926'>
            <path d='M35.418,22.788V33.041a1.866,1.866,0,0,1-1.885,1.885H4.885A1.866,1.866,0,0,1,3,33.041V22.788a1.885,1.885,0,0,1,3.77,0v8.368H31.648V22.788a1.885,1.885,0,0,1,3.77,0ZM13.027,11.894l4.3-4.41V23.806a1.885,1.885,0,1,0,3.77,0V7.521l4.3,4.373a1.913,1.913,0,0,0,1.357.565,1.952,1.952,0,0,0,1.319-.528A1.9,1.9,0,0,0,28.1,9.255l-7.539-7.69a1.911,1.911,0,0,0-2.714,0l-7.5,7.69a1.879,1.879,0,1,0,2.676,2.639Z' fill='#4569a0' transform='translate(-3 -1)'/>
        </svg>
    );
};
